module.exports = __webpack_public_path__ + "img/agra.30e4ed70.png";